import Slider, { type Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Divider, IconButton, Link } from "@mui/material";
import {
  ArrowBackIosNewRounded,
  ArrowForwardIosRounded,
} from "@mui/icons-material";

import { SchoolType } from "../../consts";
import { dmeConfig, useDevice } from "dmeditor";

const collegeList = [
  {
    id: 1,
    enabled: 1,
    code: "CT01A",
    name: "Capital Community College",
    email: "MBall-davis@ccc.commnet.edu",
    SAT: 500,
    ACT: 11,
    GPA: 2,
    phone: "800-894-6126",
    url: "www.ccc.commnet.edu",
    address: "950 Main Street",
    city: "Hartford",
    state: 65,
    zip: "06103-1207",
    years: 1,
    public: 1,
    speciality: "Technical Community College",
    gender: 1,
    religion: 53,
    housing: "No",
    founded: 1946,
    ratio_sf: "13:01",
    ratio_mf: "30:70",
    undergrads: 4075,
    grads: null,
    size: 1,
    scholar_academic: null,
    scholar_athletic: null,
    aid: 1,
    expenses_in: 12952,
    expenses_out: 31014,
    cyclelength: 1,
    degrees: "Associate,Certificate of Study",
    modified: "2020-01-01T22:41:04.000Z",
    stateInfo: {
      id: 65,
      list: "states",
      list_id: 7,
      name: "Connecticut",
      alt: "CT",
    },
  },
  {
    id: 2,
    enabled: 1,
    code: "FL14A",
    name: "Florida College",
    email: "admission@floridacollege.edu",
    SAT: 1020,
    ACT: 22,
    GPA: 2,
    phone: "800-326-7655",
    url: "www.floridacollege.edu",
    address: "119 North Glen Arven Avenue",
    city: "Temple Terrace",
    state: 68,
    zip: "33617",
    years: 2,
    public: 2,
    speciality: "Liberal Arts",
    gender: 1,
    religion: 53,
    housing: "Yes",
    founded: 1944,
    ratio_sf: "13:01",
    ratio_mf: "48:52",
    undergrads: 552,
    grads: null,
    size: 1,
    scholar_academic: 1,
    scholar_athletic: null,
    aid: 1,
    expenses_in: 30464,
    expenses_out: 30464,
    cyclelength: 1,
    degrees: "Associate,Bachelors",
    modified: "2020-01-04T19:18:05.000Z",
    stateInfo: {
      id: 68,
      list: "states",
      list_id: 10,
      name: "Florida",
      alt: "FL",
    },
  },
] as const;

export function CollectionSlider(props: { list: Array<any> }) {
  const device = useDevice();

  const settings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: device === "mobile" ? 1 : 3,
    slidesToScroll: device === "mobile" ? 1 : 3,
    prevArrow: (
      <div>
        <IconButton
          className="text-gray-400 hover:bg-inherit relative bottom-[7px] right-4"
          size="small"
        >
          <ArrowBackIosNewRounded />
        </IconButton>
      </div>
    ),
    nextArrow: (
      <div>
        <IconButton
          className="text-gray-400 hover:bg-inherit relative bottom-[7px]"
          size="small"
        >
          <ArrowForwardIosRounded />
        </IconButton>
      </div>
    ),
  };
  return (
    <div className="px-6">
      <Slider {...settings}>
        {props.list.map((college) => (
          <div key={college.id}>
            <Box className="rounded-xl overflow-hidden shadow-md bg-white mx-3">
              <Link className="no-underline" href={`/search/detail/11`}>
                <img
                  src={dmeConfig.general.imagePath(college?.image?.image || "")}
                  className="w-full h-52 object-cover"
                  alt=""
                />
                <div className="p-4">
                  <div className="font-semibold mb-4">
                    {college.name || "-"}
                  </div>
                  <div className="flex mb-4 text-gray-800">
                    <div className="text-sm">
                      {college?.years === 2 ? "4 Year" : "2 Year"}
                    </div>
                    <Divider className="mx-2" orientation="vertical" flexItem />
                    <div className="text-sm ">
                      {SchoolType.find(
                        (item) => item.value === String(college.public)
                      )?.label || "-"}
                    </div>
                  </div>
                  <div className="text-xs text-gray-500">
                    {college.address || "-"},
                  </div>
                  <div className="text-xs text-gray-500">
                    {college.city || "-"}, {college.stateInfo?.alt || ""},{" "}
                    {college.zip || "-"}
                  </div>
                </div>
              </Link>
            </Box>
          </div>
        ))}
      </Slider>
    </div>
  );
}
